import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "about" */ '../views/Index.vue')
  },
  {
    path: '/introduce',
    name: 'introduce',
    component: () => import(/* webpackChunkName: "about" */ '../views/Introduce.vue')
  },
  {
    path: '/technology',
    name: 'technology',
    component: () => import(/* webpackChunkName: "about" */ '../views/Technology.vue')
  },
  {
    path: '/vehicle',
    name: 'vehicle',
    component: () => import(/* webpackChunkName: "about" */ '../views/Vehicle.vue')
  },
  {
    path: '/digitalCloud',
    name: 'digitalCloud',
    component: () => import(/* webpackChunkName: "about" */ '../views/DigitalCloud.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import(/* webpackChunkName: "about" */ '../views/Service.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue')
  },
  {
    path: '/indexEn',
    name: 'indexEn',
    component: () => import(/* webpackChunkName: "about" */ '../views/IndexEn.vue')
  },
  {
    path: '/introduceEn',
    name: 'introduceEn',
    component: () => import(/* webpackChunkName: "about" */ '../views/IntroduceEn.vue')
  },
  {
    path: '/technologyEn',
    name: 'technologyEn',
    component: () => import(/* webpackChunkName: "about" */ '../views/TechnologyEn.vue')
  },
  {
    path: '/vehicleEn',
    name: 'vehicleEn',
    component: () => import(/* webpackChunkName: "about" */ '../views/VehicleEn.vue')
  },
  {
    path: '/digitalCloudEn',
    name: 'digitalCloudEn',
    component: () => import(/* webpackChunkName: "about" */ '../views/DigitalCloudEn.vue')
  },
  {
    path: '/serviceEn',
    name: 'serviceEn',
    component: () => import(/* webpackChunkName: "about" */ '../views/ServiceEn.vue')
  },
  {
    path: '/contactEn',
    name: 'contactEn',
    component: () => import(/* webpackChunkName: "about" */ '../views/ContactEn.vue')
  },
  {
    path: '/mapView',
    name: 'mapView',
    component: () => import(/* webpackChunkName: "about" */ '../views/MapView.vue')
  },
]

const router = new VueRouter({
  mode: 'history', // 使用 history 模式，避免 URL 中出现 #
  base: process.env.BASE_URL,
  routes,
});

export default router;

